export { default as EmbeddedEntrySwitch } from './EmbeddedEntrySwitch';
